import { includes } from 'lodash/fp'

import { Pages } from '../../types'

const stepOne = [Pages.Sell, Pages.SellCheckRegistration, Pages.SellManualLookup, Pages.SellCar]
const stepTwo = [Pages.SellDetails]
const stepThree = [Pages.SellValuationView, Pages.SellValuationUpdate]

const getCurrentStep = (page: Pages): number => {
  const isStep = includes(page)

  if (isStep(stepOne)) {
    return 0
  } else if (isStep(stepTwo)) {
    return 1
  } else if (isStep(stepThree)) {
    return 2
  } else {
    return 0
  }
}

export default getCurrentStep
